// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18":"25a7c8aa","127":"4512f18b","234":"83c40898","508":"d700e4f5","620":"21b3eab6","837":"5539125d","886":"e99b4b5e"}[chunkId] + ".js";
};